const now = new Date()

function timeSince (inputDate) {
	let reversedDate = inputDate.split('/')
	reversedDate = `${reversedDate[2]}-${reversedDate[1]}-${reversedDate[0]}`
	const date = new Date(reversedDate)

	const allMonths = now.getMonth() -
	date.getMonth() +
	12 * (now.getFullYear() - date.getFullYear())

	const months = allMonths % 12

	const years = Math.floor(allMonths / 12)

	return `${years ? `${years} ${years > 1 ? 'years' : 'year'}` : ''}${(years && months) ? ' ' : ''}${months ? `${months} ${months > 1 ? 'months' : 'month'}` : ''}`
}

const membersDatesData = Array.from(document.querySelectorAll('.time-in-company-data'))
const memberDates = Array.from(document.querySelectorAll('.time-in-company'))

membersDatesData.forEach((member, index) => {
	const memberDateValueNode = membersDatesData[index]
	const resultNode = document.createTextNode(timeSince(memberDateValueNode.textContent))
	memberDates[index].appendChild(resultNode)
})